export function getCameraErrorStatus(error = {}){
	return error && error.response ? error.response.status : null
}

export function hasNetworkFailure(error = {}){
	return Boolean(error && !error.response && (error.request || error.code === 'ERR_NETWORK' || error.message === 'Network Error'))
}

export function hasCameraNetworkFailure(error = {}){
	return hasNetworkFailure(error)
}

function getResponseMessage(error = {}){
	const data = error && error.response ? error.response.data : null
	if (!data) return ''
	if (typeof data === 'string') return data
	return data.message || data.msg || data.error || ''
}

function isTechnicalAxiosMessage(message = ''){
	return /Request failed with status code|Network Error/i.test(message)
}

function getFriendlyBackendMessage(error = {}){
	const message = getResponseMessage(error)
	return message && !isTechnicalAxiosMessage(message) ? message : ''
}

export function formatRegisteredCameraError(error, t = (_key, fallback) => fallback, fallbackKey = 'trained_face_capture_stream_unavailable'){
	const status = getCameraErrorStatus(error)
	if (status === 503) return t('trained_face_capture_error_503', 'Camera stream is not available right now. Verify the camera is online or try another camera.')
	if (status === 502) return t('trained_face_capture_error_502', 'Snapshot or stream could not be captured. Try again or check the camera connection.')
	if (status === 403) return t('trained_face_capture_error_403', 'Your session is not authorized to use this camera. Refresh the page or log in again.')
	if (status === 404) return t('trained_face_capture_error_404', 'Camera stream session was not found. Restart preview and try again.')
	if (hasCameraNetworkFailure(error)) return t('trained_face_capture_error_network', 'Backend or camera service is not reachable. Check the connection and try again.')
	return t(fallbackKey, 'Registered camera stream could not start. Upload remains available as a fallback.')
}

export function formatFaceEnrollmentError(error, t = (_key, fallback) => fallback, fallbackKey = 'trained_face_validation_error_generic'){
	const status = getCameraErrorStatus(error)
	if (status === 503) return t('trained_face_validation_error_503', 'Face validation service is not available right now. Verify the camera or validation service connection and try again.')
	if (status === 502) return t('trained_face_validation_error_502', 'Face validation service could not process the image. Try again with another photo.')
	if (status === 403) return t('trained_face_validation_error_403', 'Your session expired or is not authorized. Refresh the page or log in again.')
	if (hasNetworkFailure(error)) return t('trained_face_validation_error_network', 'Backend or validation service is not reachable. Check the connection and try again.')

	const backendMessage = getFriendlyBackendMessage(error)
	if (backendMessage) return backendMessage

	return t(fallbackKey, 'Could not validate the image. Try again with another photo.')
}
